// src/plugins/axios.js
import axios from 'axios';

// optional: set baseURL
axios.defaults.baseURL = process.env.VUE_APP_API_URL || '';

// REQUEST INTERCEPTOR
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('saa_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

export default axios;
